import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import { actionDockSetExpandReports } from '@/modules/application/actions/dock';
import Expand from './Expand';
import ListItem from './ListItem';

const Reports = (props) => {
    return (
        <>
            <ListItem title="Отчеты" to="/reports/"
                      onClick={(event) => {
                          event.preventDefault();
                          props.setExpand(!props.expand);
                      }}
            >
                <Expand expand={props.expand} setExpand={props.setExpand}/>
            </ListItem>
            <Collapse in={props.expand}>
                <List disablePadding={true}>
                    <ListItem title="Сводный" to="/reports/summary/"/>
                    {(!props.user.affiliate)
                        ? <ListItem title="Конверсия" to="/reports/conversion/"/>
                        : null
                    }
                </List>
            </Collapse>
        </>
    );
};

export default connect(
    (state) => ({
        user: state.auth.user,
        expand: state.dock.expandReports,
    }),
    (dispatch) => ({
        setExpand: bindActionCreators(actionDockSetExpandReports, dispatch),
    })
)(Reports);
